import { render, staticRenderFns } from "./AddMoneyReceipt.vue?vue&type=template&id=1517d9ee&scoped=true"
import script from "./AddMoneyReceipt.vue?vue&type=script&lang=js"
export * from "./AddMoneyReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1517d9ee",
  null
  
)

export default component.exports